module.exports = __webpack_public_path__ + "img/tutorial-pc-page3.8de6b056.png";